var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-btn-area",style:(_vm.tagPositionStyle),attrs:{"id":"signCorner"},on:{"click":function($event){return _vm.openGuide()}}},[_c('div',{staticClass:"share-img"},[_c('img',{attrs:{"src":_vm.formCustom.activityConfig.shareButtonStyleImgUrl,"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04069276","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/vibrantRubikCube/runtime/interest-form/components/share-set.vue
// module id = null
// module chunks = 